export default __webpack_public_path__ + "static/media/MenudsjinscampEast.8eab5c58.jpg";